import { animate, query, stagger, style, transition, trigger, state } from '@angular/animations';

export const fadeAnimation = trigger('fade', [
  transition('void => *', [
    style({ opacity: 0 }),
    animate('0.3s ease-in-out', style({ opacity: 1 }))
  ])
]);

export const fadeAnimationSequence = trigger('appearingItems', [
  transition('void => *', [
    query('.fade', [
      style({
        opacity: 0
      }),
      stagger(100, [animate('0.3s ease-in', style({ opacity: 1 }))])
    ])
  ])
]);

export const staggeredSlideFadeIn = trigger('staggeredSlideFadeIn', [
  transition('* => *', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(15px)' }),
        stagger('40ms', [
          animate(
            '300ms cubic-bezier(0.35, 0, 0.25, 1)',
            style({ opacity: 1, transform: 'translateY(0)' })
          )
        ])
      ],
      { optional: true }
    )
  ])
]);

export const fadeInAnimation = trigger('fadeIn', [
  state(
    'loading',
    style({
      opacity: 0,
      transform: 'translateY(20px)'
    })
  ),
  state(
    'loaded',
    style({
      opacity: 1,
      transform: 'translateY(0)'
    })
  ),
  transition('loading => loaded', [animate('300ms ease-out')]),
  transition('void => *', [
    style({
      opacity: 0,
      transform: 'translateY(20px)'
    }),
    animate('300ms ease-out')
  ])
]);
